import React from "react"
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip"
import { styled } from "@mui/material/styles"

export default function CustomTooltip({
  children,
  placement = "top",
  isDisabled,
  ...props
}) {
  const { title } = props

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip
      {...props}
      arrow
      classes={{ popper: className }}
      style={isDisabled ? { pointerEvents: "none" } : {}}
    />
  ))(() => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#404040",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#404040",
      fontFamily: "Poppins",
      fontWeight: 400,
    },
  }))

  return (
    <BootstrapTooltip title={title} placement={placement} arrow>
      {children}
    </BootstrapTooltip>
  )
}
